module.exports = __webpack_public_path__ + "static/img/yg2.bfe29b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/yg2.png
// module id = F9jz
// module chunks = 7